// ============================================================
// THE COMPANY — StatusBadge Component
// ============================================================

import { STATUS_COLORS, STATUS_LABELS } from '../../lib/constants';
import type { RoleStatus } from '../../lib/types';

interface StatusBadgeProps {
  status: RoleStatus;
  showLabel?: boolean;
  size?: 'sm' | 'md';
}

const dotSizes: Record<'sm' | 'md', string> = {
  sm: 'h-2 w-2',
  md: 'h-2.5 w-2.5',
};

const textSizes: Record<'sm' | 'md', string> = {
  sm: 'text-xs',
  md: 'text-sm',
};

export default function StatusBadge({
  status,
  showLabel = false,
  size = 'md',
}: StatusBadgeProps) {
  const color = STATUS_COLORS[status];
  const label = STATUS_LABELS[status];

  return (
    <span className="inline-flex items-center gap-1.5">
      <span
        className={`${dotSizes[size]} rounded-full shrink-0`}
        style={{ backgroundColor: color }}
        aria-hidden="true"
      />
      {showLabel && (
        <span
          className={`${textSizes[size]} font-medium`}
          style={{ color }}
        >
          {label}
        </span>
      )}
    </span>
  );
}
